/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `To be assessed` - To be assessed
 * * `Minimal Risk` - Minimal Risk
 * * `Limited Risk` - Limited Risk
 * * `High Risk` - High Risk
 * * `Prohibited / Very High Risk` - Prohibited / Very High Risk
 * @export
 */
export const EuAiActRiskClassEnum = {
  toBeAssessed: 'To be assessed',
  minimalRisk: 'Minimal Risk',
  limitedRisk: 'Limited Risk',
  highRisk: 'High Risk',
  prohibitedVeryHighRisk: 'Prohibited / Very High Risk',
} as const;
export type EuAiActRiskClassEnum = (typeof EuAiActRiskClassEnum)[keyof typeof EuAiActRiskClassEnum];

export function instanceOfEuAiActRiskClassEnum(value: any): boolean {
  for (const key in EuAiActRiskClassEnum) {
    if (Object.prototype.hasOwnProperty.call(EuAiActRiskClassEnum, key)) {
      if ((EuAiActRiskClassEnum as Record<string, EuAiActRiskClassEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EuAiActRiskClassEnumFromJSON(json: any): EuAiActRiskClassEnum {
  return EuAiActRiskClassEnumFromJSONTyped(json, false);
}

export function EuAiActRiskClassEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): EuAiActRiskClassEnum {
  return json as EuAiActRiskClassEnum;
}

export function EuAiActRiskClassEnumToJSON(value?: EuAiActRiskClassEnum | null): any {
  return value as any;
}
